export const aboutData = {
  title: "About me",
  description1: "Love to",
  description2:
    "I am a problem-solver who enjoys tackling problems in the correct Javascript way. Currently working with ",
  description3:
    " on building exceptional digital experiences. I enjoy building complex applications with modern technologies.",
  image: 1,
};
